import { render, staticRenderFns } from "./searchLabelsV.vue?vue&type=template&id=2a434013&scoped=true&"
import script from "./searchLabelsV.vue?vue&type=script&lang=js&"
export * from "./searchLabelsV.vue?vue&type=script&lang=js&"
import style0 from "./searchLabelsV.vue?vue&type=style&index=0&id=2a434013&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a434013",
  null
  
)

export default component.exports